__turbopack_context__.v({
  "profile-form": "profile-form-module-scss-module__mSKvIq__profile-form",
  "profile-form__content": "profile-form-module-scss-module__mSKvIq__profile-form__content",
  "profile-form__content--reduce-spacing": "profile-form-module-scss-module__mSKvIq__profile-form__content--reduce-spacing",
  "profile-form__fieldset": "profile-form-module-scss-module__mSKvIq__profile-form__fieldset",
  "profile-form__footer": "profile-form-module-scss-module__mSKvIq__profile-form__footer",
  "profile-form__heading": "profile-form-module-scss-module__mSKvIq__profile-form__heading",
  "profile-form__legend": "profile-form-module-scss-module__mSKvIq__profile-form__legend",
  "profile-form__separator": "profile-form-module-scss-module__mSKvIq__profile-form__separator",
  "profile-form__social-links-fields": "profile-form-module-scss-module__mSKvIq__profile-form__social-links-fields",
  "profile-form__sub-heading": "profile-form-module-scss-module__mSKvIq__profile-form__sub-heading",
});
